import { render, staticRenderFns } from "./ProductThumbnailRegistration.vue?vue&type=template&id=3b13d8d3&"
import script from "./ProductThumbnailRegistration.vue?vue&type=script&lang=ts&"
export * from "./ProductThumbnailRegistration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports